/**
 * Constantes del dominio de Administración (sedes, atendidos, configuración).
 *
 * El gating de la UI usa el MISMO permiso que exige la API y el menú del SSR: el
 * CRUD de sedes/atendidos y la configuración son **solo-admin** (`@require_admin`
 * en el SSR), cuyo equivalente en la API es el permiso `all` (ver
 * `application/api/domains/sedes.py`/`atendidos.py`/`export.py` y
 * `progress/explore_admin_ssr.md`).
 */

/** Permiso que gobierna toda la administración (sedes, atendidos, configuración). */
export const ADMIN_PERMISSION = "all";

/**
 * Diccionario de mensajes de **respaldo** por `error_code` de las APIs de sedes,
 * atendidos y exportación (`application/api/domains/sedes.py`/`atendidos.py`/
 * `export.py`).
 *
 * El backend ya entrega `message` en español, específico por dominio y a veces
 * con dato dinámico (conteo de órdenes, si lo duplicado es sede o atendido…), así
 * que `adminErrorMessage` PRIORIZA ese mensaje (ver `format.ts`). Este diccionario
 * solo se usa como respaldo cuando el error no trae un mensaje útil (algunos
 * errores de red/genéricos); por eso los textos son neutrales (no asumen sede vs.
 * atendido) y no incluyen datos dinámicos.
 */
export const ADMIN_ERROR_MESSAGE: Record<string, string> = {
  // Validación / conflicto (neutrales: el mensaje del backend, prioritario, ya
  // precisa si se trata de una sede o de un atendido y aporta el detalle).
  missing_fields: "Faltan campos obligatorios.",
  duplicate_name: "Ya existe un registro con ese nombre.",
  has_users: "No se puede eliminar porque tiene usuarios asignados.",
  has_orders: "No se puede eliminar porque tiene órdenes registradas.",
  has_talonarios: "No se puede eliminar porque tiene talonarios configurados.",
  // Exportación
  no_orders: "No hay órdenes para exportar.",
  no_dates: "No hay órdenes con fechas para exportar.",
  openpyxl_missing: "No se puede generar el Excel: falta la dependencia openpyxl.",
  // Genéricos
  not_found: "Recurso no encontrado.",
  forbidden: "No tienes permiso para esta acción.",
  http_error: "Ocurrió un error al comunicarse con el servidor.",
};
